module.exports = __webpack_public_path__ + "img/fastcharger-definitive.2728ae15.svg";